import { type ReactNode, createContext, useContext } from 'react'

type StepperContextData = {
  step: number
}

type StepperProps = {
  currentStep: number
  children: ReactNode | ReactNode[]
}

const StepperContext = createContext<StepperContextData>(
  {} as StepperContextData
)

export const Stepper = ({ currentStep, children }: StepperProps) => {
  return (
    <StepperContext.Provider value={{ step: currentStep }}>
      {children}
    </StepperContext.Provider>
  )
}

export const useStep = () => useContext(StepperContext)
